import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {AppConfig} from "../../../app.config";
import { NgbActiveModal, NgbCarousel } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ticket-images-modal',
  templateUrl: './ticket-images-modal.component.html',
  styleUrls: [ './ticket-images-modal.component.scss' ]
})
export class TicketImagesModalComponent implements OnInit, AfterViewInit {

  images: any;
  @ViewChild('myCarousel', { static: true }) myCarousel: NgbCarousel;
  @Input() selectedID = "0";

  constructor(
    public activeModal: NgbActiveModal,
    private config: AppConfig,
  ) {
  }

  getImgAbsoluteUrl(imgId) {
    if ( imgId.indexOf('assets') != -1 ) return imgId;
    else if ( imgId.indexOf('http') != -1 ) return imgId;
    else return `${this.config.getHost()}/api2/public/image?image_id=${imgId}`;
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.myCarousel.activeId = `img-${this.selectedID}`;
  }

  close() {
    this.activeModal.close("dismiss");
  }
}
